import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Action } from 'src/app/models/action-footer/action';
import { ActionButton } from 'src/app/models/action-footer/action-button';

@Injectable({
    providedIn: 'root'
})
export class ActionFooterService {
    private action = new Subject<Action>();
    private listActions = new Subject<ActionButton[]>();

    get(): Observable<Partial<Action>> {
        return this.action.asObservable();
    }

    set(action: Action): void {
        this.action.next(action);
    }

    getList(): Observable<ActionButton[]> {
        return this.listActions.asObservable();
    }

    setList(list: ActionButton[]): void {
        this.listActions.next(list);
    }
}
